
import isNil from 'lodash/isNil';
import { computed, defineComponent, ref, watch } from 'vue';
import vSelect from 'vue-select';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { Item } from '@/models/item';
import { PurchaseStore } from '@/models/purchase_store';
import items from '@/utils/prepare_items';
import stores from '@/utils/prepare_purchase_stores';

export default defineComponent({
  name: 'ContentCustomizing',

  components: {
    vSelect,
  },
  setup() {
    const { purchaseItem } = useInsertDataStore();
    const selectedItem = ref<Item | undefined>(undefined);
    const { purchaseStore } = useInsertDataStore();
    const selectedStore = ref<PurchaseStore | undefined>(undefined);

    const displayItems = computed(() => {
      if (!isNil(selectedStore.value) && selectedStore.value.isMCC) { // 店舗が選択されているかつ、MCC店舗のときのみMCC対象品を表示
        return items;
      } else {
        return items.filter((item) => !item.limitedMCC); // それ以外はMCC対象商品をフィルタ
      }
    });
    if (!purchaseItem.value) {
      purchaseItem.value = new Item();
    }

    if (!purchaseStore.value) {
      purchaseStore.value = new PurchaseStore();
    }

    // 購入店舗を選択した項目と同期
    watch(selectedStore, () => {
      purchaseStore.value! = selectedStore.value!;

      // MCC店舗以外が選択されたとき、MCC対象商品を選んでいたらリセットする
      if (!isNil(selectedItem.value) && selectedItem.value.limitedMCC) {
        selectedItem.value = undefined;
        purchaseItem.value = new Item();
      }
    });

    // 購入商品を選択した項目と同期
    watch(selectedItem, () => {
      purchaseItem.value! = selectedItem.value!;
    });

    return {
      purchaseStore,
      purchaseItem,
      items,
      stores,
      selectedItem,
      selectedStore,
      displayItems,
    };
  },

});
